module.exports = __webpack_public_path__ + "img/w7b.a5363f3a.jpg";